import { jsx as _jsx } from "react/jsx-runtime";
import HelpTriggerIcon, {} from '@helsenorge/designsystem-react/components/HelpTriggerIcon';
import { Projects, useResources } from '../../../resources';
import { useAppDispatch } from '../../../store/hooks';
import { openHjelpeskuff } from '../../store/hjelpeskuff';
import useHjelpetekst from '../../store/hooks/useHjelpetekst';
import { trackProsesshjelp } from '../../utils/analytics';
/**
 * HelpTrigger som åpner hjelpeskuffen med generell hjelpetekst for en tjeneste.
 */
const TjenesteHelpTrigger = props => {
    const { tjenesteNavn, helptriggerProps } = props;
    const dispatch = useAppDispatch();
    const { hjelpeskuffTittel, hjelpeskuffTekst, isLoading, isError } = useHjelpetekst(tjenesteNavn);
    const resources = useResources(Projects.FRAMEWORK);
    if (isLoading || isError || !hjelpeskuffTittel || !hjelpeskuffTekst) {
        return null;
    }
    const ariaLabel = helptriggerProps?.ariaLabel || resources?.visHjelpeskuffAriaLabel;
    const handleClick = (event) => {
        dispatch(openHjelpeskuff({ hjelpeskuffTittel, hjelpeskuffTekst }));
        trackProsesshjelp('TjenesteHelpTrigger', ariaLabel);
        if (helptriggerProps?.onClick) {
            helptriggerProps.onClick(event);
        }
    };
    return _jsx(HelpTriggerIcon, { ...helptriggerProps, ariaLabel: ariaLabel, onClick: handleClick });
};
export default TjenesteHelpTrigger;
